import React from 'react';
import { Reveal } from '../ui/Reveal';
import { ProcessCard } from '../ui/ProcessCard';
import { PROCESS } from '../../data/process';

export const Process = () => {
  return (
    <section className="sec" id="how-we-work">
      <Reveal><div className="slabel">Process</div></Reveal>
      <Reveal delay="1"><h2 className="stitle">How we <em>actually</em> work</h2></Reveal>
      <div className="pgrid">
        {PROCESS.map((p, i) => (
          <Reveal key={p.n} delay={((i % 2) + 1).toString()}>
            <ProcessCard process={p} />
          </Reveal>
        ))}
      </div>
    </section>
  );
};